import { ScanEye, Hand, TrendingUp, Award } from "lucide-react";
import { Reveal, ChapterLabel } from "./Reveal";

const POINTS = [
  {
    icon: ScanEye,
    title: "Understand, not memorize",
    desc: "Concepts become something students can actually see — not just hear.",
  },
  {
    icon: Hand,
    title: "Participate",
    desc: "Answer, respond and interact with the lesson right from their desk.",
  },
  {
    icon: Award,
    title: "Build confidence",
    desc: "When students can see it, they start to believe they can learn it.",
  },
  {
    icon: TrendingUp,
    title: "Perform better",
    desc: "Clearer understanding is designed to reflect in stronger results.",
  },
];

export default function ForStudents() {
  return (
    <section id="students" data-testid="students-section" className="relative py-16 sm:py-24">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <div>
            <ChapterLabel number="07" label="For Students" />
            <Reveal delay={0.1}>
              <h2
                data-testid="students-heading"
                className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.15] tracking-tight text-[#FFFDF9]"
              >
                For students.
                <br />
                Don't just memorize it.{" "}
                <span className="italic text-[#38BDF8]">Understand</span> it.
              </h2>
            </Reveal>
            <Reveal delay={0.18}>
              <p className="mt-4 max-w-md text-sm text-slate-400 leading-relaxed">
                Students learn together — seeing the same concept, in the same classroom, guided by
                their teacher.
              </p>
            </Reveal>

            <div className="mt-10 space-y-7">
              {POINTS.map((p, i) => (
                <Reveal key={p.title} delay={0.1 + i * 0.07}>
                  <div
                    data-testid={`student-point-${i}`}
                    className="flex gap-5 group"
                  >
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#38BDF8]/25 text-[#38BDF8] transition-colors duration-500 group-hover:bg-[#38BDF8]/10">
                      <p.icon size={17} strokeWidth={1.6} />
                    </div>
                    <div>
                      <h3 className="font-display text-lg text-[#FFFDF9]">{p.title}</h3>
                      <p className="mt-1 max-w-sm text-sm text-slate-400 leading-relaxed">{p.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <Reveal delay={0.2}>
            <div className="relative overflow-hidden rounded-2xl border border-white/[0.08]">
              <img
                src="/images/students-main.jpg"
                alt="Students wearing AuraXR glasses interacting with a 3D hologram while their teacher guides them"
                loading="lazy"
                className="aspect-[4/5] sm:aspect-[16/13] w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050811]/60 via-transparent to-transparent" />
              <p className="absolute bottom-5 left-5 text-[10px] tracking-[0.3em] uppercase text-slate-200/90">
                Concept experience — envisioned classroom
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
